<template>
  <div class="branded-fare-amenity">
    <div
      :class="{
        'branded-fare-amenity__top': true,
        'branded-fare-amenity__top--truncated': truncated,
      }"
    >
      <div class="branded-fare-amenity__icon">
        <vb-icon
          v-if="item.icon"
          class="d-flex align-items-center justify-content-center"
          :name="item.icon"
          :color="sass('primary')"
          :size="18"
        />
      </div>
      <div
        :class="{
          'branded-fare-amenity__text': true,
          'branded-fare-amenity__text--truncated': truncated,
        }"
      >
        <div v-if="item.txt" class="branded-fare-amenity__name">
          <div
            :id="amenity_id"
            :ref="amenity_id"
            :class="{ 'text-ellipsis': truncated }"
          >
            {{ item.txt | capitalize }}
          </div>
          <vb-icon
            v-if="item.tooltip"
            v-b-popover.hover.top="item.tooltip"
            class="ml-1"
            name="info"
            :size="14"
          />
        </div>
        <div v-if="item.description" class="branded-fare-amenity__description">
          {{ item.description | capitalize }}
        </div>
      </div>
    </div>
    <div
      v-if="with_separator"
      class="branded-fare-upsell__separator fullwidth"
    ></div>
    <b-popover
      v-if="is_text_truncated($refs[amenity_id])"
      :target="amenity_id"
      triggers="hover"
      placement="top"
      custom-class="b-popover--primary b-popover--no-arrow"
    >
      <span class="text--base">{{ item.txt | capitalize }}</span>
    </b-popover>
  </div>
</template>

<script>
  // Branded-fare amenity row: icon + label + optional tooltip and
  // description. Consumes the object returned by get_amenity_info from
  // @liveflight/resources. The swiper-item variant trails the row with a
  // separator; the table cell doesn't — `with_separator` toggles it.
  export default {
    name: 'branded-fare-amenity',
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      with_separator: {
        type: Boolean,
        default: false,
      },
      truncated: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        amenity_id: `amenity:${this._uid}`,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .branded-fare-amenity {
    display: flex;
    flex-direction: column;
    &__top {
      display: flex;
      flex-wrap: nowrap;
      flex: 1;
      align-items: flex-start;

      &--truncated {
        align-items: center;
      }
    }
    &__icon {
      width: 28px;
      margin-right: 5px;
    }
    &__text {
      flex: 1;
      font-size: 14px;
      &--truncated {
        white-space: nowrap;
      }
      overflow: hidden;
      @include font-primary-regular;
    }
    &__name {
      text-align: start;
      display: flex;
      gap: 5px;
      align-items: center;
    }
  }
</style>
